import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-scale-icon',
  templateUrl: './general-scale.component.html'
})
export class GeneralScaleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
